import { defineStore } from 'pinia'
import { useUserStore} from './user'
const events = require('events')


//import General from '@/api/General.js'; 

export const useMainStore = defineStore('main', {
  state: () => {
    return {
      // all these properties will have their type inferred automatically
      cookieConsent: false,
     
      slideover_history: [],
      slideover_show: false,

      notification_count: 0,
      has_unread_notifications: false,
      notificationPollInterval: null,

      modal_show: false,
      modal_component: null,
      modal_props: null,
      modal_fullscreen: false,

      emitter: new events.EventEmitter()
    }
  },

  getters: {

  },

  actions: {
    async init() {
        let userStore = useUserStore()
        await userStore.init()
        /*
        if(validTo && Date.parse(validTo) > Date.now()) {
          // user cookie remains active
          // -- The user is already logged in --
          await userStore.init()
        } 
        */
        //this.countries = await General.countries();        
    },

    generateString(length) {
        const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = ' ';
        const charactersLength = characters.length;
        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    },

    show_slideover(comp, props, options, name = "view") {
      let id = this.generateString(15)
      this.slideover_history.push({
        id: id,
        name: name,
        component: comp,
        properties: props,
        options: options || { width: 50 },
      })
      this.slideover_show = true
    },

    // Pop the topmost slideover. If stack becomes empty, close everything.
    pop_slideover() {
      this.slideover_history.pop()
      if (this.slideover_history.length === 0) {
        this.close_slideover()
      }
    },

    // Pop back to a specific index (closing everything above it).
    pop_to(index) {
      this.slideover_history.splice(index + 1)
      if (this.slideover_history.length === 0) {
        this.close_slideover()
      }
    },

    close_slideover() {
      this.slideover_show = false
      this.slideover_history = []

      // Query has likely been made, refresh them
      let userStore = useUserStore()
      userStore.getQueries();
    },

    update_notification_count(count) {
      this.notification_count = count
      this.has_unread_notifications = count > 0
    },

    async startNotificationPolling() {
      const User = require('@/api/User').default

      // Fetch immediately
      await this.fetchUnreadCount()

      // Then poll every 60 seconds
      this.notificationPollInterval = setInterval(async () => {
        await this.fetchUnreadCount()
      }, 60000)
    },

    async fetchUnreadCount() {
      const User = require('@/api/User').default
      try {
        const response = await User.getUnreadNotificationCount()
        if (response.status === 'success') {
          this.update_notification_count(response.count)
        }
      } catch (error) {
        console.error('Failed to fetch notification count:', error)
      }
    },

    stopNotificationPolling() {
      if (this.notificationPollInterval) {
        clearInterval(this.notificationPollInterval)
        this.notificationPollInterval = null
      }
    },

    show_modal(comp, props, fullscreen = false) {
      this.modal_props = props
      this.modal_component = comp
      this.modal_show = true,
      this.modal_fullscreen = fullscreen
    },

    close_modal() {
      this.modal_show = false
    },

    event_emit(key, data) {
      this.emitter.emit(key, data);
    },

    event_on(key, callback) {
      this.emitter.on(key, callback)
    },

    event_on_once(key, callback) {
      this.emitter.once(key, callback)
    }
  }
})
